import React from 'react'
import "../../styles/commoncomponents/assetInfoWarning.scss";

function AssetInforWarning(props) {
    return (
        <div className="assetInfo-warning">
            {props.warningText ? <p>{props.warningTextMsg} </p> : <p>Please select an asset to generate this report </p>}
            <br />
        </div>
    )
}

export default AssetInforWarning
